import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";

// Cancelling always carries a reason (the API refuses one without), like a "lost" prospect. Shared by every screen that can
// cancel a task in one gesture (the Kanban drop); the edit drawer keeps its own required "Motif" field.
export default function CancelTaskDialog({ task, onClose, onConfirm }) {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { setReason(""); }, [task]);
  const confirm = async () => {
    setSaving(true);
    try { await onConfirm(reason.trim()); } finally { setSaving(false); }
  };
  return (
    <Dialog open={!!task} onOpenChange={(open) => !open && !saving && onClose()}>
      <DialogContent>
        <DialogHeader><DialogTitle>Annuler « {task?.title} » ?</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600">La tâche sera classée dans « Annulées » avec ce motif. Vous pourrez la rouvrir ensuite.</p>
        <div className="space-y-2">
          <label htmlFor="task-cancel-reason" className="text-sm font-medium">Motif de l'annulation *</label>
          <Textarea
            id="task-cancel-reason" value={reason} onChange={(e) => setReason(e.target.value)} rows={3}
            placeholder="Pourquoi cette tâche est-elle annulée ?" data-testid="task-cancel-reason"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={saving}>Garder la tâche</Button>
          <Button onClick={confirm} disabled={saving || !reason.trim()} data-testid="confirm-cancel-task">Annuler la tâche</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
